module.exports = __webpack_public_path__ + "static/media/B_E01.ea0aa220.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/BLUE/B_E01.png
// module id = 60
// module chunks = 0